import type React from 'react'
import type { Theme } from '../../types/props.js'
export interface Feature {
  /**
   * 特性标题
   */
  title: string
}

export interface SloganProps extends React.HTMLAttributes<HTMLDivElement> {
  data: {
    /**
     * 主标题
     */
    title: string
    /**
     * 特性分组大小 默认为3
     */
    featureChunkSize?: number
    /**
     * 特性列表
     */
    features?: Feature[]
    /**
     * 主题
     */
    theme?: Theme

    tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  }
}
